import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export interface IPropertyDetailCommission {
  total: number | null;
  guaranteed: number | null;
  lease: string | null;
}

export const prepareDetailPropertyCommission = (
  data: IPropertyDetailsResponse
): IPropertyDetailCommission => {
  return {
    total: data?.total_comission ? parseFloat(data.total_comission) : null,
    guaranteed: data?.guaranteed_comission
      ? parseFloat(data.guaranteed_comission)
      : null,
    lease: data?.lease_commission || null
  };
};
